export default __webpack_public_path__ + "static/media/group-8400.a6a4dd55.png";